import BaseInputComponent from "../basecomponents/BaseInputComponent";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import {
  InputField,
  MultipleSelect,
  TextArea,
  InputSelect,
  InputSelectSearch,
} from "../components/form";
import { SmallSpinner } from "../components/loaders";

import { createPackage } from "../actions/packageActions";
import { getAllArticles } from "../actions/articleActions";
import { getAllClients } from "../actions/clientActions";

import {
  hideModal,
  refreshSelectInputs,
  refreshMultiSelect,
  addOnchangeSelect,
  initSearchSelect,
} from "../utils/domUtils";
import { getWeightOptions } from "../utils/packageUtils";

class AddPackageModal extends BaseInputComponent {
  state = {
    name: "",
    description: "",
    id_client: "",
    weight: "0",
    weight_type: "WEIGHT",
    articlesOptions: [],
    clientOptions: [],
    weightTypeOptions: [],
    errors: {},
    needRefreshSelect: false,
  };

  modal_id = "modal_add_package";
  articles = [];

  componentDidMount() {
    this.setState({
      weightTypeOptions: getWeightOptions(),
    });
    this.configureComponentProperties();
  }

  configureComponentProperties() {
    // @ts-ignore
    this.props.getAllClients();
    // @ts-ignore
    this.props.getAllArticles();
  }

  componentDidUpdate() {
    if (this.articles.length > 0) {
      refreshMultiSelect("articles", this.articles);
    }
    if (!this.state.needRefreshSelect) return;

    this.refreshDropDowns();
  }

  refreshDropDowns() {
    refreshSelectInputs();

    addOnchangeSelect("articles", () => {
      try {
        // @ts-ignore
        this.articles = $("#articles").val();
      } catch (err) {}
    });

    initSearchSelect({
      id: "id_client",
      selectedValue: this.state.id_client,
      onChange: (id_client) => {
        this.setState({
          id_client,
        });
      },
    });

    this.setState({
      needRefreshSelect: false,
    });
  }

  static getDerivedStateFromProps(nextProps, currentState) {
    let newState = {
      articlesOptions: null,
      clientOptions: null,
      needRefreshSelect: null,
      errors: null,
      changed: false,
    };
    if (nextProps.errors) {
      newState.errors = nextProps.errors;
      newState.changed = true;
    }
    if (
      nextProps.article?.elements &&
      nextProps.article.elements.length > 0 &&
      currentState.articlesOptions.length === 0
    ) {
      newState.articlesOptions = nextProps.article.elements.map((e) => ({
        value: e.id,
        label: `${e.id} ${e.name}`,
      }));
      newState.needRefreshSelect = true;
      newState.changed = true;
    }

    if (
      nextProps.client?.elements &&
      nextProps.client.elements.length > 0 &&
      currentState.clientOptions.length === 0
    ) {
      newState.clientOptions = nextProps.client.elements.map((e) => ({
        value: e.id,
        label: `${e.code || ""} ${e.name}`,
      }));
      newState.needRefreshSelect = true;
      newState.changed = true;
    }

    if (!newState.changed) return null;

    Object.keys(newState).forEach((key) => {
      if (newState[key] === null) {
        delete newState[key];
      }
    });

    return newState;
  }

  isLoading = (): boolean => {
    // @ts-ignore
    return this.props.package.loadingOperation;
  };

  clearModal = () => {
    this.setState({
      name: "",
      description: "",
    });
    this.articles = [];
    refreshMultiSelect("articles", this.articles);
  };

  onCancelClick = () => {
    hideModal(this.modal_id);
  };

  onAcceptClick = () => {
    const { name, description, id_client, weight, weight_type } = this.state;
    // @ts-ignore
    this.props.createPackage(
      {
        name,
        description,
        id_client,
        weight,
        weight_type,
        articles: this.articles,
      },
      (success) => {
        if (success) {
          this.clearModal();
          hideModal(this.modal_id);
        }
      }
    );
  };

  getForm = () => {
    const {
      name,
      description,
      id_client,
      weight,
      weight_type,
      weightTypeOptions,
      errors,
      articlesOptions,
      clientOptions,
    } = this.state;
    const loading = this.isLoading();
    return (
      <div>
        <InputField
          id="name"
          placeholder="Nombre del paquete..."
          value={name}
          error={errors}
          disabled={loading}
          onChange={this.onChangeTextInput}
        />

        <InputSelectSearch
          id="id_client"
          value={id_client}
          label="Cliente"
          options={clientOptions}
        />

        <div className="grid-2-col">
          <InputField
            id="weight"
            value={weight}
            label="Peso"
            onChange={this.onChangeTextInput}
            type="number"
          />
          <InputSelect
            id="weight_type"
            value={weight_type}
            label="Tipo"
            options={weightTypeOptions}
            addNoneOption={false}
            onChange={this.onChangeTextInput}
          />
        </div>

        <TextArea
          id="description"
          label="Descripcion (opcional)"
          value={description}
          error={errors}
          disabled={loading}
          onChange={this.onChangeTextInput}
        />

        <MultipleSelect
          id="articles"
          label="Articulos"
          options={articlesOptions}
          error={errors}
        />

        {loading && <SmallSpinner center={true} />}
      </div>
    );
  };

  render() {
    return (
      <div
        className="modal fade"
        id={this.modal_id}
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Crear nuevo paquete</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">{this.getForm()}</div>
            <div className="modal-footer">
              <div className="flex-2-separated">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={this.onCancelClick}
                >
                  Cancelar
                </button>

                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={this.onAcceptClick}
                >
                  Aceptar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// @ts-ignore
AddPackageModal.propTypes = {
  package: PropTypes.object.isRequired,
  article: PropTypes.object.isRequired,
  client: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  getAllClients: PropTypes.func.isRequired,
  getAllArticles: PropTypes.func.isRequired,
  createPackage: PropTypes.func.isRequired,
};

// @ts-ignore
AddPackageModal.defaultProps = {};

const mapStateToProps = (state) => ({
  package: state.package,
  article: state.article,
  client: state.client,
  errors: state.errors,
});

export default connect(mapStateToProps, {
  getAllClients,
  getAllArticles,
  createPackage,
})(AddPackageModal);
